import * as React from 'react';
import { GameState } from '../common/life';
import { fillArray } from '../common/util';
import { EventHandler, LifeEvents, Messages } from '../store/life';

import './LifeGrid.css';

interface LifeGridProps {
  game: GameState,
  events: LifeEvents,
}

interface LifeGridState {
  cells: Array<JSX.Element>,
  refs: Array<React.RefObject<HTMLDivElement>>,
}

class LifeGrid extends React.Component<LifeGridProps, LifeGridState> {

  constructor(props: LifeGridProps) {
    super(props);
    const dispatch = this.props.events.dispatch();

    // create a population
    const { population } = this.props.game;

    // create a corresponding array of RefObjects for the people
    const refs = fillArray(population.WIDTH * population.HEIGHT,
      () => React.createRef<HTMLDivElement>());

    const cells = refs.map((ref, i) => {
      const [x, y] = this.props.game.population.indexToXY(i);
      const toggleCellHandler: EventHandler = () => {
        dispatch(Messages.toggleCell(x, y))
      };
      return (
        <div key={i} ref={ref}
          onClick={toggleCellHandler}
          style={{
            gridColumn: x + 1,
            gridRow: y + 1,
            backgroundColor: "black",
          }}
        >&nbsp;</div>
      )});

    this.state = { refs, cells };
  }

  public componentDidMount() {
    this.updateCells(this.props, this.state);
  }

  public shouldComponentUpdate(
      nextProps: LifeGridProps,
      nextState: LifeGridState) {
    this.updateCells(nextProps, nextState);
    return false;
  }

  public render = () => (
      <div className="padded LifeGrid">{this.state.cells}</div>
  )

  private updateCells(props: LifeGridProps, state: LifeGridState) {
    const pop = props.game.population;

    state.refs.forEach((ref, i) => {
      ref.current!.style.backgroundColor = pop.index(i) ? 'black' : 'white';
    });
  }
}

export default LifeGrid;



// WEBPACK FOOTER //
// ./src/components/LifeGrid.tsx